import React from 'react';

import { useSciDomain } from 'components';
import { PAGE_REGISTRIES } from 'constants/view-registry.constants';
import { SciPage, SciTemplate } from 'enums';

export const useViewComponent = (
  viewName: SciPage = SciPage.Order,
): React.ComponentType => {
  const { data: sciDomainConfig } = useSciDomain();
  const template = sciDomainConfig?.template ?? SciTemplate.Default;
  const registry = PAGE_REGISTRIES[viewName];
  return registry[template] ?? registry[SciTemplate.Default];
};
